
define('eteration/widgets/ui-combodate',[
	'knockout',
	'eteration/widgets/widget-util',
	'underscore',
	'combodate'
	], function(ko,widgetUtil,underscore){
	
	widgetUtil.setupStringBasedTemplate(ko);
	
	ko.bindingHandlers.combodate = {
		    
			init: function (element, valueAccessor, allBindingsAccessor) {
		    	
				ko.bindingHandlers.combodate.generateComponent(element, valueAccessor, allBindingsAccessor);
		    	
				if(allBindingsAccessor().value && $.isFunction(allBindingsAccessor().value)){
			    	
					allBindingsAccessor().value.subscribe(function(newValue) {
			    		$(element).combodate({
//				    		firstItem: 'name',
		    				'setValue': newValue
			    		});
						
			    		setTimeout(function(){
				    		$('.formselect').selectpicker('refresh');
						}, 1000);
			    	});
		    	}
		    },
		    
		    generateComponent: function(element, valueAccessor, allBindingsAccessor) {
		    	
		    	var options = ko.utils.unwrapObservable(valueAccessor()) || {};

		    	var minYear, maxYear,yearDescending;
		    	var minDateAllowed = ko.utils.unwrapObservable(options.minDateAllowed);
		    	var maxDateAllowed = ko.utils.unwrapObservable(options.maxDateAllowed);

		    	var format = options.format || "YYYY-MM-DD";
		    	
		    	if(minDateAllowed) {
		    		minYear = moment(minDateAllowed, format).year();
		    	} else {
		    		var minYearsOffset = underscore.isNumber(options.minYearsOffset) ?  options.minYearsOffset : 2;
		    		minYear = new Date().getFullYear() + minYearsOffset;
		    	}
		    	
		    	if(maxDateAllowed) {
		    		maxYear = moment(maxDateAllowed, format).year();
		    	} else {
		    		var maxYearsOffset = underscore.isNumber(options.maxYearsOffset) ?  options.maxYearsOffset : 2;
		    		maxYear = new Date().getFullYear() + maxYearsOffset;
		    	}
		    	
		    	var yearDescendingOrder = underscore.isBoolean(options.yearDescendingOrder) ?  options.yearDescendingOrder : true;

	    		var template = options.template || "D MMMM YYYY";

	    		var value = ko.utils.unwrapObservable(allBindingsAccessor().value);
	    		
	    		$(element).combodate({
		    		firstItem: 'name',
	    			smartDays : true,
	    			format : format,
	    			template : template,
	    			minYear : minYear,
	    			yearDescending : yearDescendingOrder,
	    			maxYear : maxYear,
	    			customClass : "formselect inline",
	    			value: value
	    		});
	    		
	    		$('.formselect').selectpicker();
	    		
			}
		};
});